<template>
  <div>
    <div class="modal fade" id="addRequiredProjectItemsModal" ref="modalEle" tabindex="-1" role="dialog"
         aria-labelledby="modelTitleId"
         aria-hidden="true">
      <div class="modal-dialog modal-full-width" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Dodaj pozycje do Zapytania ofertowego</h5>
            <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container-fluid">

              <template v-if="!project || !team">
                <h4 class="text-warning">Najpierw wybierz projekt oraz zespół</h4>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                  <i class="bi bi-x-square me-2"></i>Zamknij
                </button>
              </template>

              <template v-else>
                <div class="col-md-12 mb-4">
                  <label>Dodaj do istniejącego zapytania</label>
                  <label class="ms-2 switch s-icons s-outline s-outline-success d-inline" style="padding-top: 3px">
                    <input
                        type="checkbox"
                        v-model="isAddingToQuoteRequest"
                        @change="showExistingQuoteRequests()"
                    >
                    <span class="slider round"></span> </label>

                  <AddToExisitingQuoteRequest ref="addToExisitingQuoteRequestModal"
                                              :isAddingToQuoteRequest="isAddingToQuoteRequest"
                                              :project="project" :team="team"
                                              @quote-request-selected="addToQuoteRequestHandle"/>

                  <div v-if="isAddingToQuoteRequest && addToQuoteRequest">
                    Wybrano zapytanie: <b>{{ addToQuoteRequest.request_number }}</b>
                    (ID:{{ addToQuoteRequest.id }})
                  </div>
                </div>

                <div v-if="selectedArticles.length > 0" class="table-responsive"
                     style="border-bottom:1px solid #ddd; padding-bottom:20px">
                  <h5>Lista wybranych artykułów</h5>
                  <table class="table table-striped">
                    <thead>
                    <tr>
                      <th></th>
                      <th>#</th>
                      <th>Nr Katalogowy</th>
                      <th>Model</th>
                      <th>J.m.</th>
                      <th>Nazwa/Opis</th>
                      <th>Ilość wymagana</th>
                      <th>Dostawcy</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="article in selectedArticles" :key="article.id">
                      <td>
                        <button @click="removeFromSelectedArticles(article.id)" class="btn btn-outline-danger btn-xs">
                          Usuń
                        </button>
                      </td>
                      <td>{{ article.id }}</td>
                      <td>{{ article.catalog_number }}</td>
                      <td>{{ article.model }}</td>
                      <td>{{ article.article_unit?.name }}</td>
                      <td>{{ article.description }}</td>
                      <td><input type="number" step="0.01" min="1" v-model="article.quantity_required"
                                 class="form-control"/></td>
                      <td>
                        <Vueform>
                          <TagsElement id="suppliers_short_names"
                                       name="suppliers_short_names"
                                       autocomplete="off"
                                       :search="true"
                                       :native="false"
                                       :items="suppliers"
                                       labelProp="short_name"
                                       valueProp="short_name"
                                       :default="article.suppliers_short_names_array"
                                       @change="changeSuppliersHandler(article, $event)">
                            <template v-slot:tag="{ option, remove }">
                                          <span
                                              :class="{
                                              'original-tag': isOriginalSupplier(option, article),
                                              'new-tag': !isOriginalSupplier(option, article)
                                            }"
                                              class="tag-item"
                                          >
                                            {{ option.short_name }}
                                            <button type="button" @click="remove">x</button>
                                          </span>
                            </template>
                          </TagsElement>
                        </Vueform>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <button type="button" class="btn btn-primary" @click="saveArticles" :disabled="isSubmitting">
                    Dodaj wybrane pozycje
                  </button>
                </div>

                <h5 class="pt-4 pb-2">Lista dostępnych artykułów</h5>
                <ejs-grid ref="addQuoteRequestItemsGrid" id="addQuoteRequestItemsGrid" height="500px"
                          :dataSource="articlesDataManager"
                          :allowPaging="true"
                          :allowSorting="true"
                          :allowFiltering="true"
                          :pageSettings="pageSettings"
                          :editSettings="editSettings"
                          :filterSettings="filterOptions"
						  :toolbar="toolbar"
						  :toolbarClick="clickToolbarHandler"
                          :selectionSettings="selectionOptions"
                          :actionBegin="actionBegin"
                          :actionComplete="actionComplete"    
						  :allowResizing="true"
                          :showColumnChooser="true"
                          :enablePersistence="true">
                  <e-columns>
                    <e-column headerText="Dodaj" width="80" :template="'addTemplate'" textAlign="Center"/>
                    <e-column field="id" headerText="ID" width="100" :isPrimaryKey="true" :visible="false"/>
                    <e-column field="photos" headerText="Zdjęcia" width="150" :template="'imageTemplate'"
                              :allowEditing="false" :allowFiltering="false" :allowSorting="false" type="string"/>
                    <e-column field="catalog_number" headerText="Nr katalogowy" type="string"/>
                    <e-column field="model" headerText="Model" type="string"/>
                    <e-column field="article_unit.id" headerText="J.m." :visible="false"/>
                    <e-column field="description" headerText="Nazwa/Opis" type="string"/>
                    <e-column field="link" headerText="Link" :defaultValue="null" type="string"
                              :filter="filterDefault" :template="'linkTemplate'" :allowEditing="false"/>
                    <e-column field="available_items.quantity" headerText="Ilość/Stany magazynowe" width="150"
                              format="N2" :filter="filterNumeric" type="string" :allowEditing="false"/>
                    <e-column field="suppliers_short_names" headerText="Dostawcy" :allowEditing="false" :dataSource="suppliers" :allowSorting="false" :allowFiltering="false"/>
                    <e-column field="producer_name" headerText="Producent" :allowEditing="false" :dataSource="producers" :allowSorting="false" :allowFiltering="false"/>
					</e-columns>

                  <template v-slot:addTemplate="{ data }">
                    <template v-if="!isArticleSelected(data.id)">
                      <button @click="addToNewItems(data)" class="btn btn-xs btn-outline-primary">Dodaj</button>
                    </template>
                    <template v-else>
                      <span class="text-success">Wybrano</span>
                    </template>
                  </template>

                  <template v-slot:linkTemplate="{data}">
                    <a class="link link-primary" target="_blank" rel="noopener noreferrer" :href=data.link>{{
                        data.link
                      }}</a>
                  </template>

                  <template v-slot:imageTemplate="{ data }">
                    <div v-if="data.photos && data.photos.length > 0">
                      <img :src="`/${data.photos[0].photo_path}`" alt="Zdjęcie"
                           style="max-height: 100px; max-width: 150px"/>
                    </div>
                  </template>

                </ejs-grid>
              </template>

            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              <i class="bi bi-x-square me-2"></i>Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Modal} from "bootstrap";
import {GridComponent, ColumnsDirective, ColumnDirective, Page, Edit, Toolbar, ColumnChooser, Reorder, Resize, Sort, Filter} from "@syncfusion/ej2-vue-grids";
import {DataManager, Predicate, Query, WebMethodAdaptor} from "@syncfusion/ej2-data";
import {usePage} from "@inertiajs/vue3";
import {createElement} from "@syncfusion/ej2-base";
import {DropDownList} from "@syncfusion/ej2-dropdowns";
import {MultiSelect} from "@syncfusion/ej2-vue-dropdowns";
import AddToExisitingQuoteRequest from './AddToExisitingQuoteRequest.vue'
import {ref} from "vue";
import addToExisitingQuoteRequest from "./AddToExisitingQuoteRequest.vue";

let dropInstanceFilterUnits, delivererElem = ref(null), multiSelectObj = ref(null);

export default {
  components: {
    AddToExisitingQuoteRequest,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective
  },
    provide: {
    grid: [Page, Edit, Toolbar, Resize, Reorder, ColumnChooser, Sort, Filter]
  },
  props: {
    project: [Number, String],
    team: [Boolean, String],
    suppliers: Object,
	producers: Object,
    addToExistingQR: Object
  },
  data() {
    return {
      modalObj: null,
      selectedArticles: [],
      isSubmitting: false,
      isAddingToQuoteRequest: false,
      addToQuoteRequest: null,
      articlesDataManager: [],
      pageSettings: {pageSize: 50, pageCount: 5, pageSizes: [10, 20, 50, 100, 200, 500, 1000]},
      filterOptions: {type: "Menu", operator: "contains"},
      filterDefault: {operator: 'contains', params: {minLength: 2}},
      filterNumeric: {operator: 'equal'},
      toolbar: this.getToolbar(),
      selectionOptions: {persistSelection: true},
      editSettings: {allowEditing: true, mode: 'Batch'},
      filterSuppliers: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.suppliers,
              fields: {text: 'short_name', value: 'short_name'},
              placeholder: 'Szukaj dostawców',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      suppliersParams: {
        create: () => {
          this.delivererElem = document.createElement("input");
          return this.delivererElem;
        },
        read: () => {
          return this.multiSelectObj ? this.multiSelectObj.value.join(",") : "";
        },
        destroy: () => {
          if (this.multiSelectObj) {
            this.multiSelectObj.destroy();
            this.multiSelectObj = null;
          }
        },
        write: (args) => {
          const values = args.rowData.suppliers_short_names || ""; // Zabezpieczenie przed null
          const selectedValues = values ? values.split(",") : [];

          this.multiSelectObj = new MultiSelect({
            value: selectedValues,
            dataSource: this.suppliers,
            fields: {text: "short_name", value: "short_name"},
            placeholder: "Wybierz dostawców",
            mode: "Box",
            allowFiltering: true,
            popupHeight: "200px",
            closePopupOnSelect: false,
          });

          this.multiSelectObj.appendTo(this.delivererElem);
        },
      },
    };
  },

  mounted() {
    this.modalObj = new Modal(this.$refs.modalEle);
    this.getArticles();
    if (this.addToExistingQR && this.addToExistingQR.status !== 'Zapytanie wysłane') {
      this.isAddingToQuoteRequest = true;
      this.addToQuoteRequestHandle(this.addToExistingQR)
    } else {
      this.isAddingToQuoteRequest = false;
    }
  },

  watch: {
    addToExistingQR: {
      handler(newVal, oldVal) {
        if (newVal && newVal.status !== 'Zapytanie wysłane') {
          this.isAddingToQuoteRequest = true;
          this.addToQuoteRequestHandle(newVal)
        } else {
          this.isAddingToQuoteRequest = false;
        }
      }
    }
  },

  methods: {
    getToolbar() {
      return [
        {text: "Resetuj filtry", prefixIcon: 'e-reset', id: 'reset_filters'},
        {text: "Lista artykułów", prefixIcon: 'e-table-of-content', id: 'articles_list'},
        {text: "Search", prefixIcon: 'e-search', id: "search", align: 'center'},
        {text: "Przywróć domyślny", prefixIcon: 'e-undo', id: "restore", align: 'right'},
        {text: "Odśwież", prefixIcon: 'e-refresh', id: "refresh", align: 'right'},
		"ColumnChooser"      ]
    },

    getArticles() {
      this.articlesDataManager = new DataManager({
        url: route('articles.get'),
        adaptor: new WebMethodAdaptor(),
        crossDomain: true,
        headers: [{'X-CSRF-TOKEN': usePage().props.csrf_token}]
      });
    },

    showExistingQuoteRequests() {
      if (this.isAddingToQuoteRequest) {
        this.$refs.addToExisitingQuoteRequestModal.show();
      }
    },

    addToQuoteRequestHandle(data) {
      this.addToQuoteRequest = data;
    },

    addToNewItems(rowData) {
      if (!this.selectedArticles.find(item => item.id === rowData.id)) {
        this.selectedArticles.push({
          ...rowData,
          original_suppliers_short_names_array: this.parseSuppliersString(rowData.suppliers_short_names),
          suppliers_short_names_array: this.parseSuppliersString(rowData.suppliers_short_names)
        });
      }
    },

    parseSuppliersString(suppliersString) {
      // Zamiana stringa "a, b, c" na ["a", "b", "c"]
      return suppliersString ? suppliersString.split(',').map(s => s.trim()) : [];
    },

    removeFromSelectedArticles(articleId) {
      this.selectedArticles = this.selectedArticles.filter(item => item.id !== articleId);
    },

    changeSuppliersHandler(article, selectedItems) {
      if (!selectedItems || selectedItems.length === 0) {
        article.suppliers_short_names_array = [];
        article.suppliers_short_names = "";
      } else {
        // Aktualizujemy array
        article.suppliers_short_names_array = selectedItems;

        // Zamieniamy array na string z przecinkami
        article.selected_suppliers_short_names = selectedItems.join(', ');
      }
    },

    isOriginalSupplier(option, article) {
      return article.original_suppliers_short_names_array.includes(option.short_name);
    },

    isArticleSelected(id) {
      return this.selectedArticles.some(item => item.id === id);
    },

    saveArticles() {
      if (!this.project || this.project === '0') {
        this.$emit("added-error", 'Nie został wybrany projekt.');
        return;
      }

      if (!this.team) {
        this.$emit("added-error", 'Nie został wybrany zespół.');
        return;
      }

      if (Object.keys(this.selectedArticles).length === 0) {
        this.$emit("added-error", 'Nie został wybrany żaden artykuł');
        return;
      }
      // Pobierz zmiany wprowadzone w tabeli
      let batchChanges = this.$refs.addQuoteRequestItemsGrid.getBatchChanges();

      // Utwórz mapę zmian wprowadzonych w edycji (np. item_required i suppliers.id)
      let changedRecordsMap = {};
      batchChanges.changedRecords.forEach(record => {
        changedRecordsMap[record.id] = record;
      });

      // Dodaj brakujące pola do każdego wybranego artykułu
      this.selectedArticles = this.selectedArticles.map(article => {
        let updatedArticle = {...article};

        // Dodaj wartości z batchChanges, jeśli istnieją
        if (changedRecordsMap[article.id]) {
          updatedArticle = {...updatedArticle, ...changedRecordsMap[article.id]};
        }
        return updatedArticle;
      });

      // zmniejsz payload
      const payload = this.selectedArticles.map(article => ({
        id: article.id,
        article_id: article.id,
        selected_suppliers_short_names: article.selected_suppliers_short_names,
        quantity_required: article.quantity_required
      }))

      console.log(this.project);

      axios.post(route("quoteRequests.addArticleToList", {
            project: this.project,
            team: this.team,
            articles: payload,
            dueDate: this.dueDate,
            isAddingToQuoteRequest: this.isAddingToQuoteRequest,
            addToQuoteRequest: this.addToQuoteRequest
          }
      )).then(response => {
        this.$nextTick(() => {

          this.$emit("added-success", "Zapytanie ofertowe stworzone poprawnie");
          this.$emit("added-article", true);
          this.selectedArticles = [];
          this.isAddingToQuoteRequest = false;
          this.addToQuoteRequest = false;
          this.hide();
        })
      }).catch(error => {
        console.log(error);
        console.log("Błąd podczas zapisywania danych:", error);
        this.$emit("added-error", error);
      })
    },

    clickToolbarHandler: async function (args) {
      if (args.item.id === 'reset_filters') {
        this.$refs.addQuoteRequestItemsGrid.clearFiltering();
      }

      if (args.item.id === 'articles_list') {
        window.open(route('articles.index'), '_blank');
      }
      if (args.item.id === 'refresh') {
        this.$refs.addQuoteRequestItemsGrid.ej2Instances.refresh();
      }
	  
	  if (args?.item.id === 'restore') {
        let grid = this.$refs.addQuoteRequestItemsGrid;
        let gridName = 'grid' + grid.$el.id;
        grid.ej2Instances.enablePersistence = false;
        window.localStorage.setItem(gridName, "");
        grid.ej2Instances.destroy();
        (function stripIdsFromUrl() {
          try {
            const url = new URL(window.location.href);
            url.searchParams.delete('ids');    // np. ?ids=1,2,3
            url.searchParams.delete('ids[]');  // np. ?ids[]=1&ids[]=2
            history.replaceState(history.state, '', url.toString());
          } catch (e) {
            const href = window.location.href;
            const cleaned = href
                .replace(/([?&])ids(\[\])?=[^&#]*&?/g, '$1')
                .replace(/[?&]$/, '');
            history.replaceState(history.state, '', cleaned);
          }
        })();

        location.reload();
      }
	   
	   
    },

    actionBegin(args) {
      //
      // WYSZUKIWARKA- wyszukiwanie wielu wartości z separatorem (przecinek
      //
      if (args.requestType === 'searching') {
        const keys = args.searchString.split(';');
        let flag = true;
        let predicate;

        if (this.$refs.addQuoteRequestItemsGrid.ej2Instances.searchSettings.key !== '') {
          this.values = args.searchString;
          keys.forEach((key) => {
            this.$refs.addQuoteRequestItemsGrid.ej2Instances.getColumns().forEach((col) => {
              if (flag) {
                predicate = new Predicate(col.field, 'contains', key, true);
                flag = false;
              } else {
                let predic = new Predicate(col.field, 'contains', key, true);
                predicate = predicate.or(predic);
              }
            });
          });

          this.$refs.addQuoteRequestItemsGrid.ej2Instances.query = new Query().where(predicate);
          this.$refs.addQuoteRequestItemsGrid.ej2Instances.searchSettings.key = '';
          this.refresh = true;
          this.valueAssign = true;
          this.removeQuery = true;
          this.$refs.addQuoteRequestItemsGrid.ej2Instances.refresh();
        } else {
          this.$refs.addQuoteRequestItemsGrid.ej2Instances.searchSettings.key = '';
          this.refresh = true;
          this.valueAssign = true;
          this.removeQuery = true;
          this.$refs.addQuoteRequestItemsGrid.ej2Instances.refresh();
        }
      }
    },

    actionComplete(args) {
      //
      // WYSZUKIWARKA - wyszukiwanie wielu wartości z separatorem (przecinek
      //
      if (args.requestType === "refresh" && this.valueAssign) {
        document.getElementById(
            this.$refs.addQuoteRequestItemsGrid.ej2Instances.element.id + "_searchbar"
        ).value = this.values;
        this.valueAssign = false;
      } else if (
          document.getElementById(
              this.$refs.addQuoteRequestItemsGrid.ej2Instances.element.id + "_searchbar"
          ).value === "" &&
          args.requestType === "refresh" &&
          this.removeQuery
      ) {
        this.$refs.addQuoteRequestItemsGrid.ej2Instances.query = new Query();
        this.removeQuery = false;
        this.$refs.addQuoteRequestItemsGrid.ej2Instances.refresh();
      }
    },

    show() {
      if (this.modalObj) this.modalObj.show();
    },
    hide() {
      if (this.modalObj) this.modalObj.hide();
    }
  }
};
</script>

<style scoped>
.tag-item {
  display: inline-flex;
  align-items: center;
  padding: 0.15em 0.5em;
  margin: 0.15em;
  border-radius: 0.25em;
}

.original-tag {
  background-color: #e0e0e0;
  color: #000;
}

.new-tag {
  background-color: orange;
  color: #fff;
}

.tag-item button {
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  margin-left: 0.5em;
}
</style>
